import { Collapse } from 'antd';
// import WebsiteForm2 from '../forms/websiteForm2'
// import { useSelector } from 'react-redux';
import Review from '../forms/reviewForm';
const { Panel } = Collapse;

const Interview = ({edit}) => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <Collapse defaultActiveKey={['0']} onChange={onChange}>
      <Panel header="Interviews/Press Conference" key="1">
     

      <Review edit={edit}/>
      </Panel>

    </Collapse>
  );
};
export default Interview;